import { Button, TextField } from '@mui/material'
import Autocomplete from '@mui/material/Autocomplete'
import axios from 'axios'
import moment from 'moment'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'

import { authContext } from '../../context/AuthContext'
import transactionStatusMap, { transactionStatusOptions } from '../helper/GlobalConstants'
import Loading from '../helper/Loading'
import PageHeader from '../helper/PageHeader'

const statusMap = transactionStatusMap
// const statusOptions = transactionStatusOptions

const AdminViewTransacViewEdit = props => {
    const [data, setData] = useState({ data: null, loading: true })
    const [mode, setMode] = useState('view') // the edit/view state

    const history = useHistory()
    const params = useParams()
    const mounted = useRef(true)
    const user = useContext(authContext)

    useEffect(() => {

        return () => mounted.current = false
    }, [])

    useEffect(() => {
        async function getTransac(id) {
            let res = null
            try {
                res = await axios.get('/api/ipay/transac/' + id)
            } catch (err) {
                res = { data: null }
            }
            console.log(res)
            if (mounted.current) {
                // setting the transaction status like this so the autocomplete can use the value
                res.data.transactionStatus = (res.data.transactionStatus === null) ? null : { label: statusMap[res.data.transactionStatus], value: res.data.transactionStatus }

                res.data.confirmationNumber = res.data.confirmationNumber || ''
                res.data.documentNumber = res.data.documentNumber || ''
                res.data.transactionAmount = res.data.transactionAmount || ''
                res.data.itemDescription = res.data.itemDescription || ''



                setData({ data: res.data, loading: false })

            }
        }

        getTransac(params.id)
    }, [params.id])

    const onEdit = () => {
        setMode('edit')
    }

    const handleChange = (event) => {
        event.persist()
        setData(prev => ({ loading: false, data: { ...prev.data, [event.target.name]: event.target.value } }))
    }

    const onSave = async () => {
        const postingData = {
            ...data.data,
            transactionStatus: data.data.transactionStatus.value,
            confirmationNumber: data.data.confirmationNumber === '' ? null : data.data.confirmationNumber,
            documentNumber: data.data.documentNumber === '' ? null : data.data.documentNumber,
            itemDescription: data.data.itemDescription === '' ? null : data.data.itemDescription,
            transactionAmount: data.data.transactionAmount === '' ? null : data.data.transactionAmount,

        }
        const res = await axios.post('/api/ipay/transac/' + params.id, postingData, {
            headers: {
                Authorization: user.accessToken
            }
        })
        console.log(res)
        setMode('view')
    }



    return <>
        <PageHeader
            title={mode==='view'? "View Transaction" : "Edit Transaction"}
            cancel={history.goBack}
        />
        {data.loading ? <Loading /> :
            data.data === null ? <h3>No Transaction found for this id</h3> :
                <>
                    <dl className="transaction-details">
                        <dt>Transaction ID:</dt>
                        <dd>{data.data.id}</dd>

                        {/* Able to edit */}
                        <dt>Transaction Document Number:</dt>
                        <dd>{mode === 'view' ? data.data.documentNumber :
                            <TextField
                                name="documentNumber"
                                type="number"
                                label="Document Number"
                                value={data.data.documentNumber}
                                onChange={handleChange}
                                fullWidth
                            />
                        }</dd>

                        {/* Able to edit */}
                        <dt>Transaction Status:</dt>
                        <dd>{mode === 'view' ? data.data.transactionStatus.label :
                            <Autocomplete
                                options={transactionStatusOptions}
                                getOptionLabel={(option) => option.label}
                                isOptionEqualToValue={(option, val) => option.value === val.value}
                                onChange={(event, value) => {
                                    event.target = {
                                        ...event.target,
                                        name: 'transactionStatus',
                                        value: value
                                    }
                                    return handleChange(event)
                                }}
                                value={data.data.transactionStatus}
                                autoHighlight
                                renderInput={(params) => <TextField {...params} label="Status Code" />}
                            />
                        }</dd>

                        {/* Able to edit */}
                        <dt>Transaction Confirmation Number:</dt>
                        <dd>{mode === 'view' ? data.data.confirmationNumber :
                            <TextField
                                name="confirmationNumber"
                                type="number"
                                label="Confirmation Number"
                                value={data.data.confirmationNumber}
                                onChange={handleChange}
                                fullWidth
                            />
                        }</dd>

                        <dt>Item Description:</dt>
                        <dd>{mode === 'view' ? data.data.itemDescription :
                            <TextField
                                name="itemDescription"
                                label="Transaction Description"
                                value={data.data.itemDescription}
                                onChange={handleChange}
                                multiline
                                rows="5"
                                fullWidth
                            />
                        }</dd>

                        <dt>Submitted Amount:</dt>
                        <dd>{"$" + data.data.submittedAmount}</dd>

                        {/* Able to edit */}
                        <dt>Transaction Amount:</dt>
                        <dd>{mode === 'view' ? "$" + data.data.transactionAmount :
                            <TextField
                                name="transactionAmount"
                                type="number"
                                label="Transaction Amount"
                                value={data.data.transactionAmount}
                                onChange={handleChange}
                                fullWidth
                            />
                        }</dd>

                        <dt>Date Submitted:</dt>
                        <dd>{moment(data.data.submittedDate).isValid() ?
                            moment(data.data.submittedDate).format('LLL') : ""}</dd>

                        <dt>Submitted by:</dt>
                        <dd>
                            <div>{"Name: " + data.data['User.first_name'] + " " + data.data['User.last_name']}</div>
                            <div>{"Username: " + data.data.submittedByUsername}</div>
                        </dd>

                        <dt>Date Completed:</dt>
                        <dd>{moment(data.data.lastModifiedDate).isValid() ?
                            moment(data.data.lastModifiedDate).format('LLL') : ""}</dd>
                    </dl>

                    {mode === 'edit' && <dl className="transaction-details">
                        <dt>&nbsp;</dt>
                        <dd>
                            <Button variant="contained" color="primary" onClick={onSave} >Save</Button>
                        </dd>

                    </dl>}
                </>

        }

    </>;
}


export default AdminViewTransacViewEdit